<script setup lang="ts">
import { Head } from "@inertiajs/vue3"

import Heading from "@/components/Heading.vue"
import InsuranceActual from "@/components/benefits/InsuranceActual.vue"
import InsuranceExt from "@/components/benefits/InsuranceExt.vue"
import InsuranceHistory from "@/components/benefits/InsuranceHistory.vue"
import InsuranceMembers from "@/components/benefits/InsuranceMembers.vue"
import AppLayout from "@/layouts/AppLayout.vue"
import { insurancePath, rootPath } from "@/routes"
import { type BreadcrumbItem } from "@/types"
import type { InsurancesShow } from "@/types/serializers"

const props = defineProps<InsurancesShow>()

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Dashboard", href: rootPath() },
  { title: "Seguro De Salud (PCF)", href: insurancePath() },
]
</script>

<template>
  <Head :title="breadcrumbs[breadcrumbs.length - 1].title" />

  <AppLayout :breadcrumbs="breadcrumbs">
    <div class="layout-container">
      <Heading
        title="Seguro de Salud Adeslas (PCF)"
        description="Gestiona tu seguro médico y el de tus familiares"
      />
      <InsuranceActual />
      <InsuranceExt v-bind="extension" />
      <InsuranceMembers v-bind="props" />
      <InsuranceHistory :data="history" />
    </div>
  </AppLayout>
</template>
